import React from 'react'
import { COMMISSION_TABLE_HEADER } from '../../interfaces/constant'
import { Tr } from 'layouts/tableLayout/_tr'
import { Td } from 'layouts/tableLayout/_td'
import { Text } from 'common/text'
import styled from 'styled-components'

const TableHeader = () => {
  return(
    <StyledTHead>
        <Tr type={'tHead'} className='create-commission-table'>
            {
                COMMISSION_TABLE_HEADER?.map(map =>{
                    return <Td key={map.id} className='create-commission-table__cell'>
                        <Text fontWeight={600}>{map.name}</Text>
                    </Td>
                })
            }
        </Tr>
    </StyledTHead>
    )
}

export default TableHeader


export const StyledTHead = styled.div`
  .create-commission-table {
    &__cell {
      cursor: pointer;
      display: flex;
      justify-content: left;
      align-items: center;
      &[data-menu='true'] {
        position: relative;
      }

      &:nth-child(1) {
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) {
        flex: 1;
        display: flex;
        align-items: center;
      }

      &:nth-child(3) {
        width: 15%;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      &:nth-child(4) {
        width: 15%;
        align-items: center;
        justify-content: center;
      }
    }
  }
` 
